import React from "react";
import { Button, Col, Row } from "reactstrap";
import { handleRequestError } from "../../../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../../../utils/notifications";
import { activatePresalePartnetMembership } from "../../../../actions/partners";
import ConfirmModal from "../../../common/confirmModal/confirmModal";

interface Partner {
  idMembresiaSocio: string;
  idPersona: string;
  idPropietario: string;
}

interface Props {
  partner: Partner;
  reload: () => any;
}

class ActivatePresaleMembership extends React.Component<Props> {
  state = {
    isOpen: false,
    waiting: false
  };

  executeActivatePresaleMembership = () => {
    const { idMembresiaSocio: membresiaSocioId } = this.props.partner;

    this.setState({ waiting: true });

    infoNotification("Activando membresía socio...");

    activatePresalePartnetMembership(membresiaSocioId)
      .then(({ data }) => {
        successNotification("Se activó la membresía socio");

        this.clearState();
        this.props.reload();
      })
      .catch((err: any) => {
        this.setState({ waiting: false });
        handleRequestError(err);
      });
  };

  clearState = () => {
    this.setState({
      isOpen: false,
      cancelMessages: [],
      cancelCharges: [],
      reasonToCancel: null,
      waiting: false
    });
  };

  render() {
    return (
      <div>
        <ConfirmModal
          title="Activar membresía socio en preventa"
          message="Se activará la membresía socio en estado de preventa. Se generará el cargo proporcional del mes corriente y la membresía operará de forma normal.  ¿Desea continuar?"
          isOpen={this.state.isOpen}
          size="md"
          waiting={!!this.state.waiting}
          ok={() => {
            this.executeActivatePresaleMembership();
          }}
          cancel={() => {
            this.setState({
              isOpen: false,
              waiting: false
            });
          }}
        />

        <Row className="p-0 m-0">
          <Col xs={4}>
            <Button
              block
              onClick={() => {
                this.setState({ isOpen: true });
              }}
              className="mt-3"
            >
              Activar membresía en preventa
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ActivatePresaleMembership;
